import axios from "axios";
import AmplifyStore from "@/store/store";
import {Auth} from '@aws-amplify/auth'
import router from "@/router";

const url_base = process.env.VUE_APP_API_BASE_URL || "https://nlwi0trsxh.execute-api.ap-southeast-2.amazonaws.com/beta";
const headers = {
  "x-api-key": process.env.VUE_APP_API_KEY,
  "Content-type": "application/json"
};

// Axios Auth interceptor. Executed for each API call made with Axios.
const authInterceptor = async (request) => {
    // Check if we are logged in, if not, don't attach anything or redirect
    if (AmplifyStore.state.user) {
        try {
            let session = await Auth.currentSession();
            // Note: Using Amplify's Auth should refresh the token if required.
            let token = await session.getIdToken().getJwtToken();
            request.headers.xspurt = token;
        } catch (err) {
            console.error('Auth error getting session/token:', err);
            await router.push('/login');
        }
    }

    return request;
}

// Attach Auth Interceptor to Axios instance
axios.interceptors.request.use(authInterceptor);

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
  response => response,
  async error => {
    if (error.response && error.response.status === 401) {
      // Only redirect to login if user was previously authenticated
      if (AmplifyStore.state.user) {
        console.error('401 Unauthorized - session expired, redirecting to login');
        // Clear the user state
        AmplifyStore.commit('setUser', null);
        // Redirect to login
        await router.push('/login');
      } else {
        // For unauthenticated users, just log the error
        console.log('401 error on public route - this might be expected for some API calls');
      }
    }
    return Promise.reject(error);
  }
);


const get = async function(endpoint) {
  return axios.get(`${url_base}/${endpoint}`, {
    headers: headers
  });
};

const get_blob = async function(endpoint) {
  return axios.get(`${url_base}/${endpoint}`, {
    responseType: "arraybuffer",
    headers: {
      // "Accept-Encoding": 'identity',
      // xspurt: token,
      ...headers
    }
  });
};

const post = async function(endpoint, data) {
  return axios.post(`${url_base}/${endpoint}`, data, {
    headers: headers
  });
};

const download_file_to_memory = async function(url, filename){
  return axios
    .get(url, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream"
      }
    })
}

const download_file = async function(url, filename) {
  // Downloads a file, not related to the API
  return axios
    .get(url, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream"
      }
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => console.error(error));
};

export { get, post, get_blob, download_file, download_file_to_memory };
